import {
  consentStatus,
  observeConsentStatusChange,
  THE_CONVERSATION_VENDOR_ID,
} from "@theconversation/shared-components/Didomi"
import { setInitialDidomiUserStatus } from "./"
import { useRegionConfig } from "modules/i18n/hooks/useRegionConfig"
import { useEffect } from "react"
import {
  doNotPersistDeviceId,
  persistDeviceId,
} from "@theconversation/shared-components/tcEventsCollector"

export const GdprConsentStatus = () => {
  const regionConfig = useRegionConfig()

  useEffect(() => {
    console.log("Running the setInitialDidomi thing.")
    const callback = (consent: boolean) => {
      console.log(`GDPR Consent Callback called with: ${consent}`)
      if (consent) persistDeviceId()
      else doNotPersistDeviceId()
    }

    observeConsentStatusChange(async () => {
      const status = await consentStatus({
        vendorId: THE_CONVERSATION_VENDOR_ID,
        purpose: "measure_content_performance",
      })
      callback(status)
    })

    setInitialDidomiUserStatus(regionConfig, callback)
  }, [regionConfig])

  return <></>
}
